const Container = ({ className = '', reference, children }) => {
  return (
    <div className={`container mx-auto ${className}`} ref={reference}>
      {children}
    </div>
  )
}

export default Container
